var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.EOSLayoutShow
      ? _c("iframe", {
          staticClass: "entry-eos-layout",
          attrs: { src: _vm.EOSUrl },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }